// extracted by mini-css-extract-plugin
export default {"mainContainer":"GolpoGhuri_mainContainer__88iaL","main":"GolpoGhuri_main__04j--","padding":"GolpoGhuri_padding__1OTWi","nextProj":"GolpoGhuri_nextProj__lh-2L"};